import { SessionStore } from './session-store.ts';
import type { ReservationConfig } from './types.ts';

export interface HomecareReservation {
  vendorId: string;
  vendorServiceId: string;
  serviceId: string;
  serviceName: string;
  servicePrice: string;
  vendorName: string;
  description: string;
  scheduledDate: string;
  scheduledMinutes: number;
  timezone: string;
  files?: string[];
  patientName?: string;
  patientBirthDate?: string;
  patientGender?: string;
}

export const homecareReservationStore = new SessionStore<HomecareReservation>(
  'homecare-reservation',
);

export const HOMECARE_RESERVATION: ReservationConfig<HomecareReservation> = {
  store: homecareReservationStore,
};
